module.exports = __webpack_public_path__ + "img/icon-cost.aba7648e.svg";